import axios from "../helpers/axioxInstance";
import URLS from "../constData/urls";

export const fetchCustomColumn = async ([body, signal]) => {

  const response = await axios.post(`${URLS.DRM_CUSTOM_COLUMN_FETCH}`,
    body, 
    {signal: signal })
  
  if (response.status >= 400) {
    throw new Error(response.message);
  }
  return response.data;
};
